module.exports = __webpack_public_path__ + "static/homeBlueBg-2f5e40255c395ba0822c353e21336652.jpg";